// store/useModuleStore.js
import { defineStore } from 'pinia'

export const useModuleStore = defineStore('module', {

    state: () => ({ currentModule: 'index' }),

    actions: {

        setModule(module) {

            this.currentModule = module

        }

    }

})
